export {
  // used in: packages/bank-accounts/src/routes/Details/Details.tsx
  BankAccountDocuments
} from './containers'

export { DocumentsPaths } from './constants'

export { routeDocumentsTree } from './routeDocumentsTree'
